import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeDeletePrescriptionMutation as useDeDeletePrescriptionMutationType } from "@/modules/patients/detail/prescription/de/services/__generated__/useDeDeletePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeDeletePrescriptionMutation($input: De_deletePrescriptionInput!) {
    de_deletePrescription(input: $input) {
      de_Prescription {
        id @deleteRecord
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeDeletePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit] = useMutationWithErrorDialog<useDeDeletePrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeletePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler] as const
}

export { useDeDeletePrescriptionMutation }
